import { createFileRoute } from "@tanstack/react-router";
import Info from "@/features/onboarding/pages/info/Info";

export const Route = createFileRoute("/$locale/$partner/_onboarding/info")({
	component: Info,
});
